import { render, staticRenderFns } from "./RemarkEntry.vue?vue&type=template&id=5ee9fa16&scoped=true&"
import script from "./RemarkEntry.vue?vue&type=script&lang=js&"
export * from "./RemarkEntry.vue?vue&type=script&lang=js&"
import style0 from "./RemarkEntry.vue?vue&type=style&index=0&id=5ee9fa16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee9fa16",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VForm,VRow,VSimpleTable,VTextField})
